import logger from 'redux-logger';
import thunk from 'redux-thunk';
import iterationRouteSetter from './iteration-route-setter';

const isLocal = process.env.NODE_ENV === 'development';
const isReduxLogger = false && isLocal;

export default [thunk, isReduxLogger && logger, iterationRouteSetter].filter(
  Boolean
);
